module.exports = __webpack_public_path__ + "static/media/seatplan-HLD.7550e387.png";